document.addEventListener('DOMContentLoaded', function () {
  let cardsCache = {};
  let loading = false;

  // $(document).on('mouseenter', '[data-swatch-url]', async function () {
  //   if (touched) return
  //   const $swatch = $(this);
  //   const swatchURL = $swatch.data('swatch-url');

  //   if (!cardsCache[swatchURL]) {
  //     cardsCache[swatchURL] = fetch(`${swatchURL}?view=card`);
  //   }
  // })
  // .on( 'touchstart', function() {
  //   touched = true;
  // });

  $(document).on('click', '[data-swatch-url]', async function () {
    if (loading) return
    const $swatch = $(this);
    const $product = $swatch.closest('.product-card');
    const $productContainer = $swatch.closest('.product-card-container');
    const swatchURL = $swatch.data('swatch-url');
    const swatchHandle = $swatch.data('swatch');

    $('.swatch-active', $product).removeClass('swatch-active');
    $swatch.addClass('swatch-active');

    try {
      if (!cardsCache[swatchURL]) {
        cardsCache[swatchURL] = fetch(`${swatchURL}?view=card`);
      }

      if ($productContainer.children(`.product-card[data-swatch="${swatchHandle}"]`).length <= 0) {
        let newProductHTML = '';
        let newProductEl = document.createElement('div');

        if (cardsCache[swatchURL] instanceof Promise) {
          $product.addClass('loading');
          loading = true
          const response = await cardsCache[swatchURL];
          newProductHTML = await response.text();
          newProductHTML = newProductHTML.replace(/loading=["']?lazy["']?/gi, '');
          newProductEl.innerHTML = newProductHTML;
          cardsCache[swatchURL] = newProductEl;
        } else {
          newProductEl = cardsCache[swatchURL];
        }

        randomiseProductCards(newProductEl);

        const $originalBrand = $('.product-brand', $product);
        $('.product-brand', newProductEl).replaceWith($originalBrand.clone());

        const $originalSwatches = $swatch.closest('.product-card__swatches');
        $('.product-card__swatches', newProductEl).replaceWith(
          $originalSwatches.clone(),
        );

        await new Promise((resolve) => setTimeout(resolve, 300));

        const $newProduct = $('.product-card', newProductEl).clone();
        $newProduct.hide();
        $newProduct.addClass('fading floating')
        $newProduct.removeClass('loading')
        // $product.replaceWith($newProduct);
        $productContainer.append($newProduct)
        $product.addClass('floating');
        $newProduct.show();
        $newProduct[0].offsetHeight;
        $newProduct.removeClass('fading');
        // setTimeout(() => {
          $product.addClass('fading');
          $product.hide();
          $newProduct.removeClass('floating');
          $product.removeClass('loading');
        // }, 100)
        loading = false
      } else {
        $product.addClass('fading floating');
        $product.fadeOut(250)
        $(`.product-card[data-swatch="${swatchHandle}"]`, $productContainer).show();
        $('.swatch-active', $product).removeClass('swatch-active');
        $(`.product-card__swatch[data-swatch="${swatchHandle}"]`, $product).addClass('swatch-active');
        $('.swatch-active', `.product-card[data-swatch="${swatchHandle}"]`).removeClass('swatch-active');
        $(`.product-card__swatch[data-swatch="${swatchHandle}"]`, `.product-card[data-swatch="${swatchHandle}"]`).addClass('swatch-active');
        $(`.product-card[data-swatch="${swatchHandle}"]`, $productContainer).offsetHeight;
        $(`.product-card[data-swatch="${swatchHandle}"]`, $productContainer).removeClass('fading');
        setTimeout(() => {
          $(`.product-card[data-swatch="${swatchHandle}"]`, $productContainer).removeClass('floating');
        }, 250)
      }
      


      if (typeof window.indentCards === 'function') {
        window.indentCards('body');
      }
    } catch (error) {
      console.error('Error updating product card:', error);
      $product.removeClass('fading loading');
    }
  });
});